export function getDataDoismesesAtras(dateString) {
    const date = new Date(dateString);

    // Subtrai 2 meses
    date.setMonth(date.getMonth() - 2);

    const mes = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() retorna 0-11
    const ano = date.getFullYear();

    return `${mes}/${ano}`;
}